module.exports = __webpack_public_path__ + "img/none-user.13ee0a26.png";